import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { personConnectButtonHidden, personConnectLabel, personConnectPhaseText, personConnectRefusalText } from './personConnect.js';
/**
 * The Connect control a tool row or the Connectors page shows (docs/DESIGN-asana-connect-from-gyro.md sections 1 and 2):
 * a button of Gyro's own interface, driven by the row's structured `connect` field, never a link. It renders on the
 * desktop app only (`flow.enabled`); the Office pane and the web hosts get nothing, and no sentence pointing at the
 * desktop. The sentence under it is one of section 5's fixed sentences; after a refusal that could never be fixed by
 * pressing again, the button goes and the sentence stays.
 */
export function PersonConnectControl({ connect, flow, compact = false }) {
    if (!flow.enabled)
        return null;
    const view = flow.flowFor(connect.family);
    const busy = view.phase === 'starting' || view.phase === 'waiting';
    const hidden = view.phase === 'error' && personConnectButtonHidden(view.code);
    const sentence = view.phase === 'error' && view.code ? personConnectRefusalText(view.code, connect.family) : undefined;
    const label = view.phase === 'connected' || view.phase === 'starting' || view.phase === 'waiting'
        ? personConnectPhaseText(view.phase, connect.family)
        : personConnectLabel(connect);
    return _jsxs("span", { className: "gyro-person-connect", "data-phase": view.phase, "data-family": connect.family, "data-compact": compact ? 'true' : undefined, children: [view.phase === 'connected'
                ? _jsx("span", { className: "gyro-person-connect-done", role: "status", children: label })
                : !hidden && _jsx("button", { type: "button", className: "gyro-settings-button gyro-person-connect-button", disabled: busy, "aria-busy": busy || undefined, onClick: () => flow.start(connect), children: label }), sentence && _jsx("span", { className: "gyro-person-connect-note", role: "status", children: sentence })] });
}
//# sourceMappingURL=PersonConnectControl.js.map